/**
 * Reads the quiz persona/path key from the checkout URL (?path=...).
 *
 * Only the seven known keys are accepted — anything else returns null, so a
 * hand-edited URL can't inject arbitrary strings into the leads table.
 *
 * Note: the quiz writes the key to both the URL and localStorage, but on the
 * LANDING origin. Checkout is a different origin, so localStorage does not
 * cross over — the URL param is the only carrier here. That's why we read the
 * param and not storage.
 */
export const QUIZ_PATHS = [
  "beginner_job",
  "beginner_freelance",
  "beginner_business",
  "freelancer_clients",
  "freelancer_pricing",
  "business_notconverting",
  "business_notrunning",
];

export function getQuizPath() {
  try {
    const p = new URLSearchParams(window.location.search).get("path");
    return QUIZ_PATHS.includes(p) ? p : null;
  } catch {
    return null;
  }
}
